import React, { useCallback, useEffect, useState } from 'react'
import api from '../../../../../services/api'
import Form, { Input } from '../../../../../components/Form'
import { SelectSearchAsync } from '../../../../../components/Form/SelectSearchAsync'

import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { BRL } from '../../../../../utils/mask'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}
type TypesFormProps = {
  isOpenInModal?: IsOpenInModalProps
  initialValues?: ContractApiResponse & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}
export const FormSetIndicator = ({
  isOpenInModal,
  initialValues
}: TypesFormProps): JSX.Element => {
  const { activeLoading, disableLoading } = useLoading()
  const { addToast } = useToast()

  const [defaultIndicatorOption, setDefaultIndicatorOption] =
    useState<SelectOptions | null>(null)

  const onSubmitForm = useCallback(
    async (data: any) => {
      try {
        try {
          activeLoading()
          await api.put(
            `/commercial/contracts/updateClientIndicatorId/${initialValues?.id}`,
            {
              client_indicator_id: Number(data.client_indicator_id),
              indicator_percent_comission: BRL(data.indicator_percent_comission)
                .value
            }
          )
          disableLoading()
          isOpenInModal?.handleOnClose?.()
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro alterado com sucesso'
          })
        } catch (error) {
          disableLoading()
          isOpenInModal?.handleOnClose?.()
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
        disableLoading()
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao atualizar',
          description:
            'Ocorreu um erro ao atualizar, por favor, tente novamente.'
        })
        isOpenInModal?.handleOnClose?.()
      }
    },
    [activeLoading, addToast, disableLoading, initialValues, isOpenInModal]
  )

  useEffect(() => {
    const indicatorId = initialValues?.client_indicator_id
    if (!indicatorId) {
      return
    }

    const loadSelectedIndicator = async () => {
      try {
        const response = await api.get(
          `/commercial/clients/view/${indicatorId}`
        )
        const client = response.data as ClientsApiResponse
        setDefaultIndicatorOption({
          value: client.id,
          name: `${client.cpf} - ${client.name}`
        })
      } catch (error) {}
    }

    loadSelectedIndicator()
  }, [initialValues?.client_indicator_id])

  return (
    <Form
      onSubmit={onSubmitForm}
      defaultValues={{
        client_indicator_id: initialValues?.client_indicator_id
      }}
    >
      <div className="card">
        <div
          className="row mb-5"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <SelectSearchAsync
            name="client_indicator_id"
            label="Indicador"
            className="col-md-12"
            placeholder="Digite para buscar indicador..."
            noOptionsMessage="Nenhum indicador encontrado"
            defaultOption={defaultIndicatorOption}
          />
          <Input
            name="indicator_percent_comission"
            label="% comissão"
            className="col-md-3"
            price
          />
        </div>
        <div className="card-footer d-flex justify-content-end py-6 px-9 pe-0">
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </div>
    </Form>
  )
}
